
import { Component, inject } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogActions, MatDialogClose, MatDialogTitle, MatDialogContent, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ScnackbarData, ToastService, SnackbarStyles } from '../toast.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DocumentTypeService } from '../../services/document-type.service';
import { DocumentType } from '../../models/DocumentType';

@Component({
    selector: 'app-dlg-add-tipo-documento',
    imports: [
    MatButtonModule,
    MatDialogActions,
    MatDialogClose,
    MatDialogTitle,
    MatDialogContent,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatProgressSpinnerModule
],
    templateUrl: './dlg-add-tipo-documento.component.html',
    styleUrl: './dlg-add-tipo-documento.component.scss'
})
export class DlgAddTipoDocumentoComponent {
  readonly dialogRef = inject(MatDialogRef<DlgAddTipoDocumentoComponent>)

  fetchingAddDocumentType = false
  snackbarData: ScnackbarData = {}

  addDocumentTypeForm = new FormGroup({
    description: new FormControl("", {
      validators: [Validators.minLength(5), Validators.required]
    })
  })

  constructor(
    private toast: ToastService,
    private documentTypeService: DocumentTypeService
  ) { }

  addDocumentType() {
    const document: DocumentType = {
      id: 0,
      descripcion: this.addDocumentTypeForm.controls.description.getRawValue()!,
      dptoId: ""
    }
    this.documentTypeService.add(document).subscribe({
      next: (response) => {
        this.snackbarData.message = "Tipo de documento agregado"
        this.snackbarData.style = SnackbarStyles.Success
        this.snackbarData.iconName = "check_circle"
        this.toast.show(this.snackbarData)
        this.fetchingAddDocumentType = false
        this.dialogRef.close(response)
      },
      error: () => {
        this.snackbarData.message = "Error agregando tipo documento"
        this.snackbarData.style = SnackbarStyles.Error
        this.snackbarData.iconName = "error"
        this.toast.show(this.snackbarData)
        this.fetchingAddDocumentType = false
        this.dialogRef.close(null)
      }
    })
  }

}
